import { KCheckbox, KDialog, KList, KTextInput } from "@kyburz/kdesign-system";
import { useDispatch } from "react-redux";
import React from "react";
import { sendSmsToDevice } from "../../../../apiCalls/config/devices";
import { setAlert } from "../../../../redux/actions/actions";

interface Props {
  selectedImeis: string[];
  smsCommand: string;
  smsModalOpen: boolean;
  toggleSMSPopup: () => void;
  handleChange: (e: any) => void;
  smsSuccess: () => void;
  handleIgnitionOn: (e: any) => void;
  ignitionOn: boolean;
}

const SMSPopup = ({
  selectedImeis,
  smsCommand,
  smsModalOpen,
  toggleSMSPopup,
  handleChange,
  smsSuccess,
  handleIgnitionOn,
  ignitionOn,
}: Props) => {
  const dispatch = useDispatch();
  const handleSMSCommand = () => {
    sendSmsToDevice(selectedImeis, smsCommand, ignitionOn).then((res: any) => {
      if (res.data) {
        dispatch(setAlert("SMS sent successfully", "success"));
        smsSuccess();
      } else {
        dispatch(setAlert("Failed to send SMS", "error"));
      }
    });
  };

  return (
    <KDialog
      size="xs"
      title="SMS Command"
      open={smsModalOpen}
      primaryCTAonClick={handleSMSCommand}
      primaryCTAColor="primary"
      primaryCTAText={`Send to ${selectedImeis.length} devices`}
      secondaryCTAonClick={toggleSMSPopup}
      secondaryCTAText="Cancel"
      hasOverflow
      disabled={!smsCommand}
    >
      <KTextInput
        placeholder="Type SMS Command"
        width="100%"
        onChange={handleChange}
        name="smsCommand"
        value={smsCommand}
      />
      <KCheckbox
        handleChange={handleIgnitionOn}
        name="ignitionOnCheckbox"
        label="Ignition On Only"
        checked={ignitionOn}
      />
      <KList
        elements={
          selectedImeis[0] === "all"
            ? [
                "Not possible to select all imeis for now. Please filter by customer or select imeis manually",
              ]
            : selectedImeis
        }
        onRowClick={() => {}}
        width="auto"
      />
    </KDialog>
  );
};

export default SMSPopup;
